<!-- 公告弹框 -->
<template>
  <div v-if="showDialog">
    <div class="master">
      <div class="pop-box">
        <div class="pop-con">
          <div class="close-btn pointer" v-if="closeBtn" @click="closeDialog"><img src="https://www.jinhanfair.com/static/home/images/close_btn.png" /></div>
          <div class="pop-logo">
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/logo.png" />
          </div>
          <div class="pop-content">
            <div class="pop-div">This browser does not support some functions of our website. To ensure you a better experience on Beijing International High-tech Exop Online Exhibition, we strongly recommend you to use Chrome browser. </div>
            <div class="pop-div">目前您的浏览器可能会不支持系统的一部分功能，为了您有一个更好的线上展览体验，请您下载谷歌最新版本浏览器，给您带来的不变敬请谅解！</div>
            <div class="text-center margin-t-24">
              <el-button type="primary" @click="goChrome()">下载Chrome</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { browser } from '@/utils/function'
export default {
  name: 'noticDialogChrome',
  components: {},
  props: {
    // 弹框显示隐藏
    nShow: {
      type: Boolean,
      default: false
    },
    closeBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showDialog: false, //是否显示弹框
      show:false, //是否显示过弹框
    }
  },

  computed: {
    dSHow() {
      return this.nShow
    }
  },

  watch: {},

  mounted() {
    if(browser.mobile) {
      this.showDialog = false
    } else {
      if(browser.isChrome || browser.isFirefox || browser.isSafari || browser.isIE11 ) {
        this.showDialog = false
      } else {
        sessionStorage.setItem('showChromeDialog', 'true')
        if(!sessionStorage.getItem('showDialog')){
          sessionStorage.setItem('showDialog', '1')
        }
        if(sessionStorage.getItem('showChromeDialog') == 'true') {
          if(sessionStorage.getItem('showDialog') == 1) {
            this.showDialog = true 
          } else {
            this.showDialog = false 
          }
        }else {
          this.showDialog = false
          sessionStorage.setItem('showChromeDialog', 'true')
        }
        if(this.showDialog == true ) {
          var num = sessionStorage.getItem('showDialog')
          sessionStorage.setItem('showDialog', ++num)
        }

      }
    }
    
  },

  methods: {
    goChrome(){
      window.open('https://www.google.cn/chrome/','_blank')
    },
    // 取消方法
    handleCancel() {
      if (typeof this.cancel === 'function') {
        this.cancel(() => {
          this.closeDialog()
        })
      } else {
        this.closeDialog()
      }
    },
    // 确认方法
    handleSure() {
      if (typeof this.sure === 'function') {
        this.sure(() => {
          this.closeDialog()
        })
      } else {
        this.closeDialog()
      }
    },
    // 弹框关闭
    closeDialog() {
      this.showDialog = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.master {
    position: fixed;
    background-color: $color-black-45;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100000;
}

.pop-box {
    position: absolute;
    width: 650px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: $color-white;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 4px;
}
.pop-logo {
    img {
      height: 32px;
    }
}

.pop-content {
    padding: 40px;

    .pop-div {
      font-size: 15px;
      line-height: 1.555;

      & + .pop-div {
        margin-top: 20px;
      }
    }
}

.close-btn {
    position: absolute;
    width: 36px;
    height: 36px;
    right: -12px;
    top: -12px;
}
.pop-btn-box {
    text-align: center;
    display: flex;
    justify-content: center;
}
.link_btn {
    display: inline-block;
    width: 280px;
    height: 56px;
    line-height: 56px;
    color: #fff;
    background: #009140;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    float: left;
}
</style>
